import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    /* Ink & paper */
    --ink: #14171a;
    --ink-soft: #52565d;
    --ink-faint: #8b8e93;
    --paper: #f1f0ea;
    --paper-raised: #fbfaf6;
    --line: #d9d7cb;
    --line-strong: #c3c1b3;
    --white: #ffffff;

    /* Accent — moutarde flat unique, jamais de dégradé */
    --accent: #d9861f;
    --accent-ink: #7a4a0f;
    --accent-tint: #f6e6cd;

    /* Diff / états fonctionnels */
    --diff-add: #2e7d4f;
    --diff-add-ink: #266741;
    --diff-add-bg: #e3ede4;
    --diff-remove: #b23a2e;
    --diff-remove-bg: #f4e6e2;

    /* rgb decomposition of --ink, for rgba() overlays */
    --ink-rgb: 20, 23, 26;

    /* Aliases historiques mappés sur le nouveau design system */
    --primary-600: var(--accent-ink);
    --primary-500: var(--accent);
    --primary-400: var(--accent);
    --primary-300: var(--accent);
    --primary-100: var(--accent-tint);
    --primary-50: #faf6ec;

    --success-500: var(--diff-add);
    --success-100: var(--diff-add-bg);
    --success-50: var(--diff-add-bg);

    --danger-500: var(--diff-remove);
    --danger-100: var(--diff-remove-bg);
    --danger-50: var(--diff-remove-bg);

    --warning-500: var(--accent-ink);
    --warning-100: var(--accent-tint);

    --gray-900: var(--ink);
    --gray-800: var(--ink);
    --gray-700: var(--ink-soft);
    --gray-600: var(--ink-soft);
    --gray-500: var(--ink-faint);
    --gray-400: var(--ink-faint);
    --gray-300: var(--line-strong);
    --gray-200: var(--line);
    --gray-100: var(--paper);
    --gray-50: var(--paper-raised);

    /* Flat : pas d'ombres */
    --shadow-sm: none;
    --shadow-md: none;
    --shadow-lg: none;
    --shadow-primary: none;

    /* 4px partout */
    --radius-sm: 4px;
    --radius-md: 4px;
    --radius-lg: 4px;
    --radius-xl: 4px;

    /* Couleurs uniquement, pas de transform au hover */
    --transition-fast: 0.15s ease;
    --transition-normal: 0.15s ease;
    --transition-slow: 0.15s ease;
  }

  * {
    box-sizing: border-box;
  }

  body {
    font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    margin: 0;
    padding: 0;
    background-color: var(--paper);
    color: var(--ink-soft);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Sora', 'IBM Plex Sans', sans-serif;
    color: var(--ink);
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: 0;
    margin: 0;
  }

  h1 {
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 8px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 16px;
  }

  code, pre, .mono {
    font-family: 'IBM Plex Mono', monospace;
  }

  a {
    color: var(--accent-ink);
    text-decoration: none;
    transition: color var(--transition-fast);
  }

  a:hover {
    color: var(--accent);
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  input, select, textarea {
    font-family: inherit;
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--paper);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--line-strong);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--ink-faint);
  }

  /* Focus States */
  *:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 3px;
  }

  /* Selection */
  ::selection {
    background-color: var(--accent-tint);
    color: var(--accent-ink);
  }
`;

export default GlobalStyle;
